module.exports = __webpack_public_path__ + "static/img/bigmodel_white.9d8af326.png";